'use client';

import { Button } from '@sympla/sympla-components';
import * as styles from './CompleteDataBottomSheet.css';

export type CompleteDataBottomSheetProps = {
  isOpen: boolean;
  deadline: string;
  completionPercentage: number;
  onComplete: () => void;
  onDismiss: () => void;
};

function CompleteDataBottomSheet({
  isOpen,
  deadline,
  completionPercentage,
  onComplete,
  onDismiss,
}: CompleteDataBottomSheetProps) {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onDismiss();
    }
  };

  return (
    <div
      className={styles.overlay}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="complete-data-title"
    >
      <div className={styles.bottomSheet}>
        <div className={styles.handle} />

        <h2 id="complete-data-title" className={styles.title}>
          Complete seus dados até {deadline}
        </h2>

        <div className={styles.progressContainer}>
          <div className={styles.progressBarBackground}>
            <div
              className={styles.progressBarFill}
              style={{ width: `${completionPercentage}%` }}
            />
          </div>
          <span className={styles.progressPercentage}>
            {completionPercentage}%
          </span>
        </div>

        <p className={styles.description}>
          E garanta{' '}
          <span className={styles.descriptionBold}>
            mais segurança no acesso
          </span>{' '}
          à sua conta!
        </p>

        <Button
          fullWidth
          color="brand"
          upperCase={false}
          onClick={onComplete}
        >
          Completar agora
        </Button>

        <Button
          fullWidth
          variant="outline"
          color="neutral"
          upperCase={false}
          onClick={onDismiss}
          externalClassName={styles.secondaryButtonMargin}
        >
          Completar depois
        </Button>
      </div>
    </div>
  );
}

export default CompleteDataBottomSheet;
